import { css, type SerializedStyles } from "@emotion/react";

import { getSpaceVariable } from "../components/space/utilities";
import type { TextVariant } from "../components/Text/types";
import type { BriefBlockType } from "./schema";
import type { TitleLevel } from "./schema/blocks/title";

export const MARGINS_BY_BLOCK_TYPE: Record<BriefBlockType, SerializedStyles> = {
    title: css({
        marginBlockStart: getSpaceVariable(6),
        marginBlockEnd: getSpaceVariable(2),
    }),
    body: css({
        marginBlockEnd: getSpaceVariable(1),
    }),
    listItem: css({
        marginBlockEnd: getSpaceVariable(1),
        display: "flex",
        alignItems: "flex-start",
        gap: getSpaceVariable(2),
        "& > :last-child": {
            flex: 1,
            minWidth: 0,
        },
    }),
};

export const TITLE_LEVEL_VARIANT: Record<TitleLevel, TextVariant> = {
    1: "heading",
    2: "subheading",
    3: "heading3",
};

export const LIST_ITEM_MARKER = css({
    flex: "0 0 auto",
    minWidth: "1.5em",
    lineHeight: "var(--rs-line-height-body-1)",
});
